import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { getLenis } from "./SmoothScroll";

// Jump to the top on every route change. Lenis keeps its own eased scroll
// target, so a plain window.scrollTo can be overwritten on the next frame if
// the user was still mid-scroll when they clicked; resetting Lenis directly
// avoids that.
const resetScroll = () => {
  const lenis = getLenis();
  if (lenis) lenis.scrollTo(0, { immediate: true, force: true, lock: false });
  window.scrollTo(0, 0);
};

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) return undefined; // hash links handle their own scrolling
    resetScroll();
    // Once more after the route transition has swapped the page content.
    const raf = requestAnimationFrame(resetScroll);
    return () => cancelAnimationFrame(raf);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
